namespace RioERP.Users {
    export interface FranchiseeRow {
        Id?: number;
        Name?: string;
        Description?: string;
        Email?: string;
        AlternateEmail?: string;
        AffiliateId?: string;
        Mobile?: string;
        AlternateMobile?: string;
        Address?: string;
        City?: string;
        StateId?: number;
        UserId?: number;
        AvailableCreditBalance?: number;
        Gstin?: string;
        Pan?: string;
        GstCertificate?: string;
        BankName?: string;
        BankAccountType?: Web.Enums.BankAccountType;
        BankAccountName?: string;
        BankAccountNo?: string;
        BankIfscCode?: string;
        Pincode?: number;
        IsActive?: boolean;
        IsCustomer?: boolean;
        CustomerId?: number;
        DiscountCoupon?: string;
        IsPostPayAllowed?: boolean;
        IsGstInApplied?: boolean;
        StateName?: string;
        StateIsActive?: boolean;
        StateInsertUserId?: number;
        StateInsertDate?: string;
        StateUpdateUserId?: number;
        StateUpdateDate?: string;
        StateIsHomeState?: boolean;
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserMobilePhoneNumber?: string;
        UserMobilePhoneVerified?: boolean;
        UserTwoFactorAuth?: number;
        CustomerName?: string;
        CustomerEmailId1?: string;
        CustomerEmailId2?: string;
        CustomerMobile1?: string;
        CustomerMobile2?: string;
        CustomerIsActive?: boolean;
        CustomerInsertUserId?: number;
        CustomerInsertDate?: string;
        CustomerUpdateUserId?: number;
        CustomerUpdateDate?: string;
        CustomerECustomerType?: number;
        CustomerGstin?: string;
        CustomerCouponCode?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace FranchiseeRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Users.Franchisee';
        export const lookupKey = 'Users.Franchisee';

        export function getLookup(): Q.Lookup<FranchiseeRow> {
            return Q.getLookup<FranchiseeRow>('Users.Franchisee');
        }
        export const deletePermission = 'Users:UsersManagement:Modify';
        export const insertPermission = 'Users:UsersManagement:Modify';
        export const readPermission = 'Users:UsersManagement:View';
        export const updatePermission = 'Users:UsersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            Description = "Description",
            Email = "Email",
            AlternateEmail = "AlternateEmail",
            AffiliateId = "AffiliateId",
            Mobile = "Mobile",
            AlternateMobile = "AlternateMobile",
            Address = "Address",
            City = "City",
            StateId = "StateId",
            UserId = "UserId",
            AvailableCreditBalance = "AvailableCreditBalance",
            Gstin = "Gstin",
            Pan = "Pan",
            GstCertificate = "GstCertificate",
            BankName = "BankName",
            BankAccountType = "BankAccountType",
            BankAccountName = "BankAccountName",
            BankAccountNo = "BankAccountNo",
            BankIfscCode = "BankIfscCode",
            Pincode = "Pincode",
            IsActive = "IsActive",
            IsCustomer = "IsCustomer",
            CustomerId = "CustomerId",
            DiscountCoupon = "DiscountCoupon",
            IsPostPayAllowed = "IsPostPayAllowed",
            IsGstInApplied = "IsGstInApplied",
            StateName = "StateName",
            StateIsActive = "StateIsActive",
            StateInsertUserId = "StateInsertUserId",
            StateInsertDate = "StateInsertDate",
            StateUpdateUserId = "StateUpdateUserId",
            StateUpdateDate = "StateUpdateDate",
            StateIsHomeState = "StateIsHomeState",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            UserEmail = "UserEmail",
            UserSource = "UserSource",
            UserLastDirectoryUpdate = "UserLastDirectoryUpdate",
            UserUserImage = "UserUserImage",
            UserInsertDate = "UserInsertDate",
            UserInsertUserId = "UserInsertUserId",
            UserUpdateDate = "UserUpdateDate",
            UserUpdateUserId = "UserUpdateUserId",
            UserIsActive = "UserIsActive",
            UserMobilePhoneNumber = "UserMobilePhoneNumber",
            UserMobilePhoneVerified = "UserMobilePhoneVerified",
            UserTwoFactorAuth = "UserTwoFactorAuth",
            CustomerName = "CustomerName",
            CustomerEmailId1 = "CustomerEmailId1",
            CustomerEmailId2 = "CustomerEmailId2",
            CustomerMobile1 = "CustomerMobile1",
            CustomerMobile2 = "CustomerMobile2",
            CustomerIsActive = "CustomerIsActive",
            CustomerInsertUserId = "CustomerInsertUserId",
            CustomerInsertDate = "CustomerInsertDate",
            CustomerUpdateUserId = "CustomerUpdateUserId",
            CustomerUpdateDate = "CustomerUpdateDate",
            CustomerECustomerType = "CustomerECustomerType",
            CustomerGstin = "CustomerGstin",
            CustomerCouponCode = "CustomerCouponCode",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
